import { Status } from '-/Common/Status'
import { defineComponent } from 'vue'
import CellMixin from '../CellMixin'

export default defineComponent({
  name: 'OrderTagCell',
  mixins: [CellMixin],
  setup(props) {
    return () => <Status type={props.text === 1 ? 'success' : 'error'}>{props.text === 1 ? '正常' : '禁用'}</Status>
  }
})
